// extracted by mini-css-extract-plugin
module.exports = {"label":"PerformanceComponent_label__1HSJ9","maxHeight15Em":"PerformanceComponent_maxHeight15Em__1P-Nj"};